const RentOrGiveaway = () => {
  return (
    <>
      <section>
        <p>Policy</p>
        <p>Effective Date: 03/10/2026</p>
        <p>Last Updated: 03/10/2026</p>
      </section>
      <section className="mt-6">
        <h2 className="text-xl font-semibold">1. What’s This All About?</h2>
        <p>
          Hey! This is just a simple agreement for using the [RentGiveaway].
          It’s meant for us to share stuff easily and hassle-free. By using the
          app, you agree to play nice and follow the few guidelines listed here.
          Let’s keep it fun!
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">2. What This App Does</h2>
        <p>
          This app is just for us to share items. I (the Admin) can add or
          remove items, and you guys can see what’s available and borrow them
          whenever you need.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">3. Using Your Account</h2>
        <ul className="list-disc ml-6">
          <li>Use the account I provided to log in and browse items.</li>
          <li>
            Don’t mess with anyone else’s account. It’s just us here anyway!
          </li>
          <li>Keep your login details to yourself. Simple and safe.</li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">
          4. What I Can Do (Admin Powers!)
        </h2>
        <ul className="list-disc ml-6">
          <li>I can add, update, or remove items anytime.</li>
          <li>If something’s not available, I’ll update it ASAP.</li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">5. Borrowing Stuff</h2>
        <ul className="list-disc ml-6">
          <li>Check what’s available and ask to borrow what you need.</li>
          <li>Take care of what you borrow and bring it back in good shape.</li>
          <li>
            Try to return items on time. It’s all about being cool with each
            other!
          </li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">6. Let’s Not Do This</h2>
        <ul className="list-disc ml-6">
          <li>No messing with the app or borrowed stuff.</li>
          <li>
            No trying to hack or break the app’s security. It’s just for us,
            anyway!
          </li>
          <li>No sharing your account details with random people.</li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">7. Just to Be Clear</h2>
        <ul className="list-disc ml-6">
          <li>This app is as-is. No guarantees, but it should work fine.</li>
          <li>
            If anything goes wrong, I’m not responsible for what happens with
            the items. Just use common sense and care.
          </li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">8. Privacy Stuff</h2>
        <p>
          I’m not collecting anything from you other than what’s needed for
          logging in and managing the app. No data-selling nonsense here.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">9. Changing Things Up</h2>
        <p>
          If I ever update this agreement, I’ll let you know. Using the app
          after changes means you’re cool with them.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-xl font-semibold">10. Need to Talk?</h2>
        <p>
          Just reach out to me at learnHube@gmail.com if you have any questions
          or issues. This is all meant to keep things smooth and easy!
        </p>
      </section>
    </>
  );
};

export default RentOrGiveaway;
